import { useEffect, useState } from "react";

export const  useWindowWidth = ()=> {
  // Initialize state with current window width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function that updates the state
    const handleResize = () => setWindowWidth(window.innerWidth);

    // Add event listener on mount
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth;
}
